export const UPDATE_COLLECTION = 'UPDATE_COLLECTION [COLLECTIONS]';
export const CREATE_COLLECTION = 'CREATE_COLLECTION [COLLECTIONS]';
export const DELETE_COLLECTION = 'DELETE_COLLECTION [COLLECTIONS]';
export const ADD_CARD_TO_COLLECTION = 'ADD_CARD_TO_COLLECTION [COLLECTIONS]';
export const REMOVE_CARD_FROM_COLLECTION = 'REMOVE_CARD_FROM_COLLECTION [COLLECTIONS]';

import { notificationPrompt } from 'js/store/notification/notification.actions';
import { getCollectionDataAndTypeById } from 'js/store/collections/Collections.selectors';

export const updateCollection = (id, name, removeCards) => {
  return (dispatch, getState) => {
    dispatch(notificationPrompt({ type: 'UPDATE_COLLECTION', additionalData: false }));

    dispatch({
      type: UPDATE_COLLECTION,
      payload: { id, name, removeCards },
    });
  };
};

export const addCardToCollection = (id, cardId) => {
  return (dispatch, getState) => {
    const collectionData = getCollectionDataAndTypeById(getState(), id);

    dispatch(
      notificationPrompt({
        type: 'ADD_CARD_TO_COLLECTION',
        additionalData: { name: collectionData?.collection?.name || '' },
      })
    );

    dispatch({
      type: ADD_CARD_TO_COLLECTION,
      payload: { id, cardId },
    });
  };
};

export const removeCardFromCollection = (id, cardId) => {
  return (dispatch, getState) => {
    const collectionData = getCollectionDataAndTypeById(getState(), id);

    dispatch(
      notificationPrompt({
        type: 'REMOVE_CARD_FROM_COLLECTION',
        additionalData: { name: collectionData?.collection?.name || '' },
      })
    );

    dispatch({
      type: REMOVE_CARD_FROM_COLLECTION,
      payload: { id, cardId },
    });
  };
};

export const createCollection = ({ id, name, cards }) => {
  return (dispatch, getState) => {
    dispatch(notificationPrompt({ type: 'CREATE_COLLECTION', additionalData: false }));
    dispatch({
      type: CREATE_COLLECTION,
      payload: { id, name, cards },
    });
  };
};

export const deleteCollection = (id) => {
  return (dispatch, getState) => {
    const collectionData = getCollectionDataAndTypeById(getState(), id);

    dispatch(
      notificationPrompt({
        type: 'DELETE_COLLECTION',
        additionalData: { name: collectionData?.collection?.name || '' },
      })
    );

    dispatch({
      type: DELETE_COLLECTION,
      payload: { id },
    });
  };
};
